import { TransactionsPage } from 'features/transactions';

export const TechOperatorTransactionsPage: React.FC = () => (
  <TransactionsPage />
);
